<template>
    <div>
        <v-card>
            <v-card-actions class="mx-3">
                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-3 white--text" small color="green" depressed @click="export2xls">Export to XLS</v-btn>
            </v-card-actions>
            <v-card-subtitle>
                <div style="text-align:center; font-weight:bold; font-size:16px; padding:10px">PO Per Outlet</div>

                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Start Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="startDate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="startDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="volume" class="compact-form"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">End Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="endDate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="endDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center text-right">
                        <v-spacer></v-spacer>
                        <v-btn depressed color="primary" @click="runReport">Run</v-btn>
                    </v-col>

                </v-row>

            </v-card-subtitle>

            <v-card-text class="ml-3 mr-3">

                <div style="overflow:auto">
                    <v-simple-table fixed-header height="400px" ref="tableBOM" class="">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <!-- <th rowspan="2">Kode</th> -->
                                    <th rowspan="2">Produk</th>
                                    <template v-for="coor in pivotedReport.coordinators">
                                    <th :key="coor" :colspan="pivotedReport.coordinatorOutlets[coor].length" class="text-center">{{ coor }}</th>
                                    </template>
                                </tr>
                                <tr>
                                    <template v-for="coor in pivotedReport.coordinators">
                                      <template v-for="outlet in pivotedReport.coordinatorOutlets[coor]">
                                        <th :key="coor + '-' + outlet" class="text-center">{{ outlet }}</th>
                                      </template>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                              <tr v-for="row in pivotedReport.rows" :key="row.product_code">
                                <!-- <td style="white-space:nowrap"></td> -->
                                <td style="white-space:nowrap">{{ row.product_code }} - {{ row.product_name }}</td>
                                <template v-for="(qty, idx) in row.quantities">
                                  <td class="text-center" :key="row.product_code + '-' + idx">{{ qty }}</td>
                                </template>
                              </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <!-- </table> -->
                </div>
            </v-card-text>
        </v-card>
        <v-overlay :value="onLoad" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>        

    </div>
</template>

<script>
import moment from 'moment'
import { utils, writeFileXLSX } from 'xlsx';

export default {

    data: () => ({
        dialog: false,
        onLoad: false,
        printObj: [],
        dateMenu: false,
        startDate: null,
        endDate: null,
        volume: null,
        endDateMenu: false,
        startDateMenu: false,
        bottles: [],
        pivotedReport: {
            coordinators: [],
            coordinatorOutlets: {},
            outletNames: [],
            products: [],
            rows: []
        }
    }),

    computed: {
      miscCodes() {
        return this.$store.state.misccode.objs
      },

    },

    watch: {
    },

    filters: {
        moment: function (date) {
            return moment(date).format('D MMM YYYY');
        },
        numbers: function (number) {
            return Number(number).toLocaleString()
        },
    },

    async created() {
        this.getBottles();
    },

    methods: {
        async runReport() {
            this.onLoad = true
            this.printObj = (await this.$store.dispatch('getObjs', {apidomain:'reports/po-per-outlet?start_date='+this.startDate+'&end_date='+this.endDate+'&volume='+this.volume, parameter:''})).data.data.items
            this.pivotedReport = this.pivotReport();
            this.onLoad = false
        },
        onProgress(progress) {
            this.progress = progress;
            console.log(`PDF generation progress: ${progress}%`)
        },
        export2xls() {
            console.log(this.$refs.tableBOM.$el.firstChild.firstChild)
            const wb = utils.table_to_book(this.$refs.tableBOM.$el.firstChild.firstChild)
            writeFileXLSX(wb, "PO-Per-Outlet.xlsx")

        },
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        pivotReport() {
            // Get unique outlet names in order
            const outletNames = Array.from(new Set(this.printObj.map(i => i.name)));
            // Get unique coordinators in order
            const coordinators = Array.from(new Set(this.printObj.map(i => i.coordinator)));

            // Group outlet names by coordinator
            const coordinatorOutlets = {};
            coordinators.forEach(coor => {
            coordinatorOutlets[coor] = outletNames.filter(name =>
                this.printObj.some(i => i.coordinator === coor && i.name === name)
            );
            });

            // Get unique products
            const products = Array.from(
            new Map(this.printObj.map(i => [i.product_code, { code: i.product_code, name: i.product_name }]))
                .values()
            );

            // Build rows
            const rows = products.map(product => {
            const row = {
                product_code: product.code,
                product_name: product.name,
                quantities: []
            };
            coordinators.forEach(coor => {
                coordinatorOutlets[coor].forEach(outlet => {
                const found = this.printObj.find(i =>
                    i.product_code === product.code &&
                    i.name === outlet &&
                    i.coordinator === coor
                );
                row.quantities.push(found ? found.quantity : '');
                });
            });
            return row;
            });

            return {
                coordinators,
                coordinatorOutlets,
                outletNames,
                products,
                rows
            };
        }
    }    
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}

/* Sticky columns for Kode and Produk */
/* th.sticky-col, td.sticky-col {
  position: sticky;
  left: 0;
  background: white;
  z-index: 2;
} */

/* Enable horizontal scrolling for the table */
.freeze-column-table .v-data-table__wrapper {
  overflow-x: auto;
}

/* Sticky first column */
.freeze-column-table th:nth-child(1),
.freeze-column-table td:nth-child(1) {
  position: sticky;
  left: 0;
  background-color: #fff; /* Match table background */
  z-index: 3; /* Higher than other rows */
  border-right: 1px solid #ddd; /* Optional border */
}

</style>